module.exports = __webpack_public_path__ + "twilio-logo.png";